/*
  SvgIcon.jsx
*/

// Npm.
import React, { useMemo } from 'react';

// Makes.
import { makeStyles, cx } from '../../makes/makeStyles';

// Styles.
const useStyles = makeStyles({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontSize: '1.5rem',
  },
});

/**
 * Component to wrap an icon.
 */
export default function SvgIcon({ className, ...rest }) {

  const classes = useStyles();
  const cls = useMemo(() => cx('SvgIcon', classes.root, className), [classes.root, className]);

  return (
    <svg
      className={cls}
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      {...rest}
    />
  );
}
